import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import { Button } from "antd";
import { addBooking, getBookings, getMemberById } from "../../api/booking";
import { setLoader } from "../../reducers/global";
import Modal from "react-modal";
import "./modal.css";
import { setBookingsList } from "../../reducers/bookings";
import { WarningFilled } from "@ant-design/icons";
import {clearSelectedDay, setLoading} from "../../useAppPullState";
import {syncWithServer} from "../actions/syncWithServer";
import {SelectHomeCourseModalStore} from "./SelectHomeCourseModalStore";

const generateUuid = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, character => {
    const random = (Math.random() * 16) | 0;
    const value = character === "x" ? random : (random & 0x3) | 0x8;

    return value.toString(16);
  });
};

export default ({ course, data, setData, handleCloseModal, handleOpenModal, showModal, setBookings, booking, socket }) => {
  const [firstName, setFirstName] = useState("");
  const {locations, homeCourse} = SelectHomeCourseModalStore.useState();
  const [lastName, setLastName] = useState("");
  const [memberId, setMemberId] = useState("");
  const [unknown, setUnknown] = useState("");
  const [phone, setPhone] = useState("");
  const [isPaid, setIsPaid] = useState(false);
  const [member, setMember] = useState(null);



  const selectedCourse = locations.find(loc => loc.id === homeCourse?.courseId);

  // console.log('member bookings', { homeCourse});

  const [book, setBook] = useState([]);

  useEffect(() => {
    if (!!booking) setBook(booking);
  }, [booking]);

  const resetForm = type => {
    // setFirstName("");
    // setIsPaid(false);
    // setLastName("");
    // setPhone("");
    // if (type === true) setMemberId("");
    // setUnknown("");
  };

  useEffect(() => {
    // console.log({ data });
    if (data.auth !== null) {
      setFirstName(data.auth.firstName || "");
      setLastName(data.auth.LastName || "");
      setPhone(data.auth.Phone || "");
      setIsPaid(true);
      setMemberId(data.auth.SgsMemberId);
    }
  }, [data]);

  const checkAdvanceBooking = id => {
    let bookedSlots = book?.filter(boo => {
      // console.log({
      //   today: moment().date().valueOf(),
      //   boo: moment(boo?.data.date, "DD/MM/YYYY").valueOf() != moment().valueOf(),
      //   date: moment(boo?.data.date, "DD/MM/YYYY").valueOf(),
      // });
      return (
        moment(boo?.data.date, "DD/MM/YYYY").valueOf() > moment().valueOf() &&
        moment(boo?.data.date, "DD/MM/YYYY").valueOf() != moment().valueOf() &&
        boo.data.memberId == id &&
        boo.data.course.id == course.id
      );
    });
    // console.log({ bookedSlots });

    if (bookedSlots.length > 0) return true;
    else return false;
    // console.log({ bookedSlots });
  };
  moment("2010-10-20").isAfter("2010-01-01", "year");
  //   console.log(uuid());
  const onSubmit = async e => {
    e.preventDefault();
    let postUser = null;
    if (!data?.auth?.userName) {
      postUser = {
        userName: data.auth.Email,
        roleId: 1,
        role: "member",
        firstName: data?.auth?.firstName,
        LastName: data?.auth?.LastName,
      };
    }
    let model = {
      firstName,
      lastName,
      memberId,
      //   unknown,
      phone,
      isPaid,
      docName: generateUuid(),
      date: data.date,
      user: postUser ? postUser : data.auth,
      homeCourse: {
        id: homeCourse?.courseId,
        title: `${selectedCourse?.title}, ${selectedCourse?.abbreviation}`
      },
      course: course,
      timeStamp: moment(data.date.substring(3, 5) + "/" + data.date.substring(0, 2) + "/" + data.date.substring(6, 11)).valueOf(),
      createdDateTime: moment().valueOf(),
      inAdvanceBooking:
        moment(data.date.substring(3, 5) + "/" + data.date.substring(0, 2) + "/" + data.date.substring(6, 11)).valueOf() >
        moment().valueOf(),
    };
    setLoading(true);
    await addBooking(model, data => {

      setTimeout(() => {
        syncWithServer()
        resetForm(true);
        toast.success("pelioikeus varattu");
        handleCloseModal();
      }, 3000)

    });


    // dispatch(setLoader(false));
  };
  return (
    <div>
      <Modal
        isOpen={showModal}
        contentLabel='Example Modal'
        className='Modal'
        overlayClassName='Overlay'
        id='ngdialog12'
        style={{}}
        // ariaHideApp={false}
      >
        <div className='container'>
          <div className='row'>

            <div
              className='col-6 close-ico'
              style={{ color: "red", textAlign: "right" }}
              onClick={() => {
                // setMember(null);
                handleCloseModal();
              }}
            >
              <span> x </span>
            </div>
          </div>
          <div className='row' style={{ color: "black", textAlign: "center", fontWeight: 600 }}>
            <span class='col-form-label'>Lisää varaustiedot</span>
          </div>
          <div className='row' style={{ color: "black", marginBottom: 8, paddingBottom: 4 }}>
            <div className='col-sm-6 col-lg-5 col-md-5'>{course?.data?.courseName}</div>
            <div className='col-sm-6 col-lg-5 col-md-5'>{data?.date}</div>
            <div className='col-sm-4 col-lg-2 col-md-2'>
            </div>
          </div>
          <form>
            <div className='row' style={{ color: "black", paddingTop: 8 }}>
              <div class='col-sm-6'>
                <input
                  type='text'
                  class='form-control'
                  placeholder='first name'
                  value={firstName}
                  //   onChange={e => setFirstName(e.currentTarget?.value || "")}
                />
              </div>
              <div class=' col-sm-6'>
                <input
                  type='text'
                  class='form-control'
                  placeholder='last name'
                  value={lastName}
                  //   onChange={e => setLastName(e.currentTarget?.value || "")}
                />
              </div>
            </div>
            <div className='row' style={{ color: "black", paddingTop: 8 }}>
              <div className='col-12'>
                <input
                  type='text'
                  class='form-control'
                  placeholder='member id'
                  value={memberId}
                  onChange={e => {
                    // resetForm(false);
                    // setMemberId(e.currentTarget?.value);
                    // if (e.currentTarget?.value != "" && e.currentTarget?.value != null && e.currentTarget?.value != undefined) {
                    //   dispatch(setLoader(true));
                    //   getMemberById({ SgsMemberId: `${e.currentTarget.value}` }, res => {
                    //     console.log("res", res);
                    //     if (res.status) {
                    //       setMember(res.data.response);
                    //     } else {
                    //       resetForm(true);
                    //       setMember(null);
                    //     }
                    //   });
                    //   dispatch(setLoader(false));
                    // } else if (
                    //   e.currentTarget?.value == "" ||
                    //   e.currentTarget?.value == null ||
                    //   e.currentTarget?.value == undefined
                    // ) {
                    //   setMember(null);
                    // }
                  }}
                />
              </div>
              <div className='col-12'>
                <input
                  type='text'
                  class='form-control'
                  placeholder='home course'
                  value={`${selectedCourse?.title}, ${selectedCourse?.abbreviation}`}
                />
              </div>
            </div>

            <div className='row' style={{ color: "black", paddingTop: 8 }}>
              <div className='col-2'>

                <div style={{ paddingLeft: 8 }}>
                  <WarningFilled
                    color='gray'
                    style={{ verticalAlign: "center", color: "gray", height: 32, width: 32, fontSize: 40 }}
                  />
                </div>
              </div>
              <div className='col-10'>
                <p>Huomioi kentän omat varaussäännöt ennen varausta</p>
              </div>
            </div>
            <div className='row' style={{ background: "yellow", marginInline: 5 }}>
              <div className='col-2'></div>
              <div className='col-10'>
                <div style={{ marginLeft: -10 }}>
                  <p style={{ paddingRight: 18, color: "black" }}>{course.data.preOrderRules}</p>
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-12' style={{ textAlign: "center", padding: 12 }}>
                <Button
                  className='btn btn-info btn-submit'
                  disabled={!isPaid}
                  onClick={e => {
                    onSubmit(e);
                  }}
                >
                  VAHVISTA
                </Button>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </div>
  );
};
